import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import PrivacyModal from './PrivacyModal';
import TermsModal from './TermsModal';

const FooterWrapper = styled.footer`
  background-color: var(--secondary-color);
  padding: 40px 0;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const PrivacyLink = styled.button`
  background: none;
  border: none;
  color: var(--text-color);
  font-size: 0.9rem;
  font-weight: 600;
  margin-left: 15px;
  text-decoration: underline;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  vertical-align: baseline;
  opacity: 0.7;

  &:hover {
    color: var(--accent-color-1);
    opacity: 1;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    justify-content: flex-end;
  }
`;

const Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <FooterWrapper>
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-4 mb-md-0">
            <div style={{ marginBottom: '1rem' }}>
              <img src="/naniaraeb_white.png" alt="NARNIA LAB" style={{ height: '18px', width: 'auto' }} />
            </div>
            <div style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.4)', lineHeight: '1.6' }}>
                <p className="mb-1">(주)나니아랩 대표자: 김찬석, 김홍일 | 사업자등록번호: 201-86-48902</p>
                <p className="mb-1">통신판매업신고번호: 2026-울산북구-0079 | 전화: 010-4027-9445</p>
                <p className="mb-0">주소: 울산광역시 북구 농공단지1길 32-8, 북구청년창업지원센터</p>
            </div>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <LinkContainer>
                <PrivacyLink onClick={() => setShowPrivacy(true)} style={{ marginLeft: 0 }}>개인정보 처리방침</PrivacyLink>
                <PrivacyLink onClick={() => setShowTerms(true)} style={{ marginLeft: 0 }}>이용약관</PrivacyLink>
            </LinkContainer>
            <p style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.3)', margin: 0 }}>
              © 2025 Narnia Lab. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>

      <PrivacyModal show={showPrivacy} onHide={() => setShowPrivacy(false)} />
      <TermsModal show={showTerms} onHide={() => setShowTerms(false)} />
    </FooterWrapper>
  );
};

export default Footer;
